import React, { useCallback } from 'react';
import classnames from 'classnames/bind';
import { ReactComponent as ChatAgentIcon } from 'modules/onboarding/OnboardingChatForm/components/InitWidget/welcome-message-icon.svg';
import { useFormFieldValue } from 'modules/taboola-common-frontend-modules/formData';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { chatSender } from '../../consts/chatState';
import { useVersionNavigation } from '../../hooks/useVersionNavigation';
import { ChatHistory } from './ChatHistory';
import { ChatInput } from './ChatInput';
import { VersionNavigation } from './VersionNavigation';
import styles from './chat.module.scss';

const classNameBuilder = classnames.bind(styles);

export const Chat = ({ onSubmit, containerClassName }) => {
    const { value: landingPageId } = useFormFieldValue({ field: 'landingPageId' });
    const { value: chatHistory = [], onChange: onChatHistoryChange } = useFormFieldValue({ field: 'chatHistory' });
    const disabled = !landingPageId;

    // Version navigation state and handlers
    const {
        versionNumber,
        totalVersions,
        canNavigatePrevious,
        canNavigateNext,
        isLoading: isHistoryNavigationLoading,
        navigateToPrevious,
        navigateToNext,
    } = useVersionNavigation();

    const handleMessageSubmit = useCallback(
        async (message, sender) => {
            const newChatHistory = [...chatHistory, { sender, text: message, timestamp: Date.now() }];
            onChatHistoryChange(newChatHistory);
            await onSubmit();
        },
        [chatHistory, onChatHistoryChange, onSubmit]
    );

    return (
        <div className={classNameBuilder('container', containerClassName)}>
            <div className={styles['header']}>
                <div className={styles['header-content']}>
                    <ChatAgentIcon className={styles['chat-agent-icon']} />
                    <FormattedMessage id="app.chat.agent.title" defaultMessage="Abby AI" />
                </div>

                <VersionNavigation
                    currentIndex={versionNumber}
                    totalVersions={totalVersions}
                    hasPrevious={canNavigatePrevious}
                    hasNext={canNavigateNext}
                    onPrevious={navigateToPrevious}
                    onNext={navigateToNext}
                    disabled={disabled}
                    isLoading={isHistoryNavigationLoading}
                />
            </div>
            <ChatHistory
                disabled={disabled}
                isLoading={isHistoryNavigationLoading}
                onSuggestionSubmit={message => handleMessageSubmit(message, chatSender.user)}
            />
            <ChatInput
                onUserInput={message => handleMessageSubmit(message, chatSender.user)}
                disabled={disabled || isHistoryNavigationLoading}
            />
        </div>
    );
};
